import type { XYChartYAxisProps } from '../types/xy-chart-props.js';

export const YAxis = (props: XYChartYAxisProps) => null;

YAxis['displayName'] = 'XYChart.YAxis';
